import { giphyDarkGrey } from '@giphy/colors'
import { ReactNode } from 'react'
import styled from 'styled-components'
import CreationToolGradient from '../types/gradient'
import { GradientButton } from './buttons'
import { PauseIcon } from './icons'
import ProgressBarComponent from './progress-bar'

const Button = styled(GradientButton)<{ $size: number }>`
    height: ${({ $size }) => $size}px;
`

const ProgressButton = styled(GradientButton)<{ $size: number }>`
    background: ${giphyDarkGrey};
    cursor: default;
    height: ${({ $size }) => $size}px;
    position: relative;

    &:hover {
        animation: none;
    }

    &:active {
        opacity: 1;
    }

    span {
        text-shadow: 0 2px 6px rgba(0, 0, 0, 0.33);
        position: relative;
    }
`

const ProgressBar = styled(ProgressBarComponent)`
    left: 0;
    position: absolute;
    top: 0;
`

const PauseButton = styled(GradientButton)<{ $size: number }>`
    flex-shrink: 0;
    height: ${({ $size }) => $size}px;
    margin: 0;
    padding: 0;
    width: ${({ $size }) => $size}px;

    svg {
        display: block;
        height: 16px;
    }
`

type Props = {
    className?: string
    children?: ReactNode
    disabled?: boolean
    progress?: number
    gradient?: CreationToolGradient
    size?: number
    isUploading?: boolean
    url?: string
    onClick?: () => void
    onPause?: () => void
}

const CreationUploadButton = ({
    className,
    children,
    progress = 0,
    disabled = false,
    gradient = CreationToolGradient.IndigoPurple,
    size = 42,
    isUploading = false,
    url,
    onClick,
    onPause,
}: Props) => {
    const colors = CreationToolGradient.colors(gradient)
    const baseProps = { disabled, className, colors, onClick }

    if (isUploading) {
        return (
            <ProgressButton $size={size} className={className} colors={colors}>
                <ProgressBar progress={progress}>
                    {onPause && (
                        <PauseButton $size={size} colors={colors} onClick={onPause}>
                            <PauseIcon />
                        </PauseButton>
                    )}
                </ProgressBar>
                <span>{children}</span>
            </ProgressButton>
        )
    }

    if (url) {
        return (
            <Button
                $size={size}
                {...{
                    ...baseProps,
                    as: 'a',
                    href: url,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                }}
            >
                {children}
            </Button>
        )
    }

    return (
        <Button $size={size} {...baseProps}>
            {children}
        </Button>
    )
}

export default CreationUploadButton
